<label fxLayoutAlign="start center" class="checkbox">
  <input type="checkbox" class="checkbox--input" [ngModel]="isChecked" (ngModelChange)="onModelChange($event)" />
  <div fxLayoutAlign="center center" class="checkbox--custom-input" [ngClass]="{ thin: isThinStyle }">
    <mat-icon svgIcon="checkbox" *ngIf="isChecked"></mat-icon>
  </div>
  <span *ngIf="label" class="checkbox--label">{{ label }}</span>
</label>
